import './App.css';
import React, {useState, useEffect} from "react";
import DoorHopperMap from './components/DoorHopperMap';
import Navigation from './components/Navigation';
import AppointmentsList from "./components/AppointmentsList";
import NotificationBar from './components/NotificationBar';
import ClientDetails from './components/ClientDetails';
import LoadingScreen from './components/LoadingScreen';
import {AppCTX} from './data/AppContext';
import Login from './components/Login';
import ProspectDetails from './components/ProspectsList.js';
import TeamSignUp from './components/TeamSignUp';
import SearchAppBar from './components/TopBar';
import Container from '@mui/material/Container';

function App() {
  const[height, setHeight] = useState(window.innerHeight)
  const[width, setWidth] = useState(window.innerWidth)
  
  // triggering new deployment 
  useEffect(() => {
    // Function to update the inner height state
    const handleResize = () => {
      setHeight(window.innerHeight);
      setWidth(window.innerWidth);
    };

    // Add an event listener for the resize event when the component mounts
    window.addEventListener('resize', handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const {
    newProspect,
    setNewProspect,
    leadType,
    prospects,
    setProspects,
    setLeadType,
    status,
    setStatus,
    user,
    isMapLoaded,
  } = React.useContext(AppCTX);


  const renderViews = (leadType) => {
    if (leadType === 0){
      return(
        <ProspectDetails prospects={prospects} />
      )
    }else if (leadType === 1){
      return(
        <AppointmentsList />
      )
    }else{
      <></>
    }
  }
  
  if(user.uid==null){
    return(
      <div style={{height:'100%', width:'100%'}}  className="App">
        <LoadingScreen/>
        <Login/>
      </div>
    )
  }
  else if(user.uid!=null && user.data==null){
    return (
      <div style={{height:'100%', width:'100%'}} className="App">
        <TeamSignUp/>
      </div>
    )
  }else{
    return (
      <div style={{height:'100%', width:'100%'}} className="App"> 
        {
          !isMapLoaded?
          <LoadingScreen />:null
        }       
        <div style={
          {
            position:'fixed',
            top:0,
            zIndex:1,
            width:'100vw'
          }
        }>
          <SearchAppBar/>
        </div>
        <div style={{
            position:'fixed',
            top:0,
            width:width,
            height: height*0.7,
            zIndex:'0',
            marginTop:50,
          }}>
          <DoorHopperMap
            prospects={prospects}
            apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            setProspects={setProspects}
            leadType={leadType}
            newProspect={newProspect}
            setNewProspect={setNewProspect}
          />
        </div>
        <div style={{
          position:'fixed',
          bottom:0,
          zIndex:'2',
          width:width,
          height:leadType === 1? height:height*0.32
        }} id="views">
          <Container maxWidth="md">
            {renderViews(leadType)}
          </Container>
        </div>
        <div style={
          {
            zIndex:'3'
          }
        }>
          <Navigation setCurrentScreen={setLeadType} currentScreen={leadType}/>
        </div>
        <div style={
          {
            position:'fixed',
            bottom:0,
            left:40,
            zIndex:'4'
          }
        }>
          {status!=='neutral'? <NotificationBar setStatus={setStatus} status={status}/>:null}
        </div>
      </div>
    );
  }
}

export default App;
